import { RESET_VIEW_GLOBAL } from 'store/global/actionType';

export const RESET_VIEW = RESET_VIEW_GLOBAL;



// WEBPACK FOOTER //
// ./src/components/page/ObjectFilter/flow/actionTypes.js